module.exports = __webpack_public_path__ + "static/media/dxiconsmaterial.dc2bcb9e.ttf";